<template>
    <vue-final-modal
        v-model="show"
        name="switch-currency-confirmation-modal"
        classes="switch-currency-confirmation-modal vizion-modal-container"
        content-class="vizion-modal-content"
        :esc-to-close="escToClose"
    >
        <div style="padding: 20px;">
            <h4 class="subtitle text-center">Zmenou meny prídete o produkty v košíku.</h4>
            <div class="row justify-content-between">
                <button class="button primary" style="background-color: #36413E;" @click="show = false">Zatvoriť</button>
                <button class="button primary" style="background-color: #DDEA46;" @click="switchCurrency">Zmeniť menu</button>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import axios from "axios";
import { onMounted, reactive, toRefs, inject } from 'vue'

export default {

    setup() {

        const state = reactive({
            show: false,
            escToClose: true,
            csrf: null,
            selected_currency: null,
        })

        const emitter = inject('emitter')

        onMounted( () => {
            emitter.on('switch-currency-confirmation-modal', function(data) {
                state.show = true
                state.selected_currency = data
            })
        })

        function switchCurrency() {
            axios.put('/setCurrency', {
                shortcut: state.selected_currency,
            })
            .then( response => {
                location.reload();
            })
            .catch( error => console.error(error) )
        }

        return {
            ...toRefs(state),
            switchCurrency
        }
    }
}
</script>
